import config from 'config';

const isProd = () => {
  return !config.ADMIN_API_URL.includes('dev') && !config.ADMIN_API_URL.includes('stage');
};

export default isProd;
